import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

export function ConsoleLayout() {
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto bg-gray-50 p-6">
        <Outlet />
      </main>
    </div>
  );
}
